const SEVERITY = {
	HIGH: 1,
	MEDIUM: 2,
	LOW: 3,
};

export default SEVERITY;
